import {Component, input, signal} from '@angular/core';
import {FormControl} from "@angular/forms";
import {MessageService} from "primeng/api";
import {AuthService, OAuthState} from "../../services/auth/auth.service";
import {flagTermsRequired} from "../terms-conditions-checkbox/terms-conditions-checkbox.component";

@Component({
  selector: 'homey-login-with-apple-button',
  imports: [],
  standalone: true,
  templateUrl: './login-with-apple-button.component.html',
})
export class LoginWithAppleButtonComponent {
  public readonly oathState = input.required<OAuthState>();
  constructor(
    private readonly authService: AuthService,
    private readonly messageService: MessageService,
  ) {
  }

  termsControl = input.required<FormControl<boolean>>();
  loading = signal(false);

  private agreedToTerms() {
    return this.termsControl().value;
  }

  async onLoginWithApple() {
    if (this.loading()) {
      return;
    }

    if (!this.agreedToTerms()) {
      flagTermsRequired(this.termsControl(), this.messageService);
      return;
    }
    this.loading.set(true);
    try {
      await this.authService.socialLogin(
        'apple',
        this.oathState(),
        this.agreedToTerms(),
      );
    } finally {
      this.loading.set(false);
    }
  }
}
